<script setup>
const route = useRoute()
const areaCategory = getAreaCategory(route.params.area)
const areaName = computed(() => areaCategory === 'area' ? route.params.area : getAreaByPrefKey(route.params.area).key)
useCustomMeta(areaCategory, getFullPrefectureName(route.params.area))
const breadCrumbList = getBreadCrumb(route.params.area, areaCategory)
if (!getAreaPrefectureName(route.params.area)) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid Path'
  })
}
const { data: mapPosition } = await useFetch('/api/kosa/mapConfig', { query: { path: route.params.area } })
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :area="areaCategory==='area'? getAreaPrefectureName(route.params.area) : ''"
      :area-roma="areaCategory==='area'? route.params.area : ''"
      :pref="areaCategory==='pref'? getAreaPrefectureName(route.params.area) : ''"
      :pref-roma="areaCategory==='pref'? route.params.area : ''"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <KosaMap
          :map-position="mapPosition"
          :title="getAreaPrefectureName(route.params.area)"
        />
      </div>
      <template #main-bottom>
        <LivecamList
          v-if="areaCategory!=='pref'"
          :area="route.params.area"
        />
        <KosaCityList
          v-if="areaCategory==='pref'"
          :pref="route.params.area"
        />
        <KosaPrefList
          v-if="route.params.area!=='okinawa'"
          :area="areaName"
        />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.satellite {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .slider {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    .content {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
    }
  }
  .info {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding-top: 20px;
  }
  .box {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 10px;
    background-color: #eef1f8;
  }
}
.main {
  .satellite {
    @media screen and (min-width: 830px) {
      .box {
        padding-inline: 15px;
      }
    }
  }
}
</style>
